import { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

// Interval at which to check expiration
const INTERVAL_CHECK_MS = 30 * 1000; // 30 secs
// Time until we force page refresh.
// Our maximum time before refresh is necessary is actually cloudfront media expiry
// which is ~72 hours. However, we force refresh after 12 hours to keep sessions
// shorter, for somewhat more sensible analytics.
const EXPIRE_TIME_MS = 60 * 60 * 12 * 1000; // 12 hours

/**

  After EXPIRE_TIME_MS display a modal which tells the user they must refresh the 
  page.

  Instead of setting a single timeout == page expiration we instead check the clock time 
  on an interval. This way we can be confident we have correct time even if JS runtime 
  has been inactive.

*/
class NeedsRefreshManager extends Component {

  constructor(props) {
    super(props);
    autobind(this);
  }

  componentDidMount() {
    this._mountDateTime = new Date();
    this._interval = setInterval(this.handleInterval, INTERVAL_CHECK_MS);
  }

  componentWillUnmount() {
    clearInterval(this._interval);
  }

  shouldComponentUpdate() {
    return false;
  }

  handleInterval() {
    const timeSinceMountMs = (new Date()).getTime() - this._mountDateTime.getTime();
    if (timeSinceMountMs >= EXPIRE_TIME_MS) {
      this.props.onNeedsRefreshDisplay();
      clearInterval(this._interval);
    }
  }

  render() {
    return this.props.children;
  }
}

NeedsRefreshManager.propTypes = {
  onNeedsRefreshDisplay: PropTypes.func.isRequired
};

export default NeedsRefreshManager;